<template>
  <div
    class="kd-image-effects__item"
    :class="[
      itemClassWithId,
      { 'kd-image-effects__item--active': isActive }
    ]"
    @click="onCLick"
  >
    <div class="kd-image-effects__thumb">
      <div
        class="kd-image-effects__thumb-image"
        :style="{ backgroundImage: backgroundImageCss }"
      ></div>
    </div>
    <div class="kd-image-effects__label">{{ label }}</div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import {
  ACTIVATE_EFFECT_FOR_ACTIVE_LAYER,
  DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER,
} from '@/store/mutation-types';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemClassWithId() {
      return `kd-image-effects__item--${this.id}`;
    },
    backgroundImageCss() {
      if (this.imageUrl) {
        return `url(${this.imageUrl})`;
      }
      // else return placeholder image
      return `linear-gradient(to right bottom, transparent 49.5%, #999, transparent 50.5%),
              linear-gradient(to left bottom, transparent 49.5%, #999, transparent 50.5%);`;
    },
  },
  methods: {
    ...mapMutations([
      ACTIVATE_EFFECT_FOR_ACTIVE_LAYER,
      DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER,
    ]),
    onCLick() {
      if (!this.id || this.id === 'normal') {
        this.DEACTIVATE_EFFECTS_FOR_ACTIVE_LAYER();
      } else {
        this.ACTIVATE_EFFECT_FOR_ACTIVE_LAYER(this.id);
      }
    },
  },
};
</script>

<style lang="scss">
.kd-image-effects__thumb-image {
  width: 100%;
  height: 100%;
  background-size: cover;
}

.kd-image-effects__thumb {
  width: 62px;
  height: 38px;
  margin-bottom: 8px;

  @media all and (max-height: 680px) {
    margin-bottom: 4px;
  }
}

.kd-image-effects__item {
  // the css filter is not set on the element directly because this would
  // also color the border, which is shown on active and hover state
  &--grayscale {
    .kd-image-effects__thumb-image {
      filter: grayscale(100%);
    }
  }

  &--sepia {
    .kd-image-effects__thumb-image {
      filter: sepia(100%);
    }
  }
}

.kd-image-effects__label {
  font-size: 11px;
  font-style: italic;
  text-align: center;
}

.kd-image-effects__item {
  cursor: pointer;

  &--active, &:hover {
    .kd-image-effects__thumb {
      border: 2px solid #00A6DD;
    }
    .kd-image-effects__label {
      color: #00A6DD;
    }
  }
}
</style>
